__webpack_require__.p = "https://partner.admin.cargooapp.com/";